import React, { Component } from 'react'
import { v4 as uuidv4 } from 'uuid'
import { observer } from 'mobx-react'
import * as R from 'ramda'
import i18n from 'i18next'

import Select from '../../../form/Select'
import Button from '../../../../UniformComponents/Button'
import Input from '../../../form/Input'

@observer
class Questions extends Component {
    addQuestion = () => {
        const { store } = this.props
        const { formData } = store

        const questions = formData.questions.slice()
        questions.push({ id: uuidv4() })

        store.formData = R.set(R.lensPath(['questions']), questions, formData)
    }

    setQuestion = (obj, id) => {
        const { store } = this.props
        const { formData } = store
        const questions = formData.questions.slice()
        const questionIndex = questions.findIndex((q) => q.id === id)
        if (questionIndex > -1) {
            questions.splice(questionIndex, 1, { id: uuidv4(), questionId: obj.value, obj })
        }

        store.formData = R.set(R.lensPath(['questions']), questions, formData)
    }

    removeQuestion = (id) => {
        const { store } = this.props
        const { formData } = store
        const questions = formData.questions.slice()
        const questionIndex = questions.findIndex((q) => q.id === id)
        if (questionIndex > -1) {
            questions.splice(questionIndex, 1)
        }

        store.formData = R.set(R.lensPath(['questions']), questions, formData)
    }

    render() {
        const { store } = this.props
        const { questions: qlistQuestions, formData } = store
        const { questions } = formData

        return (
            <div id="questions" className="section">
                <h3>{i18n.t('certification.question.title')}</h3>
                <div className="section">
                    {questions.map(({ id, obj, questionId }) => (
                        <div key={id} className="questionList">
                            <Select
                                options={qlistQuestions}
                                value={obj}
                                defaultValue={questionId}
                                onBlur={(obj) => this.setQuestion(obj, id)}
                            />
                            <i
                                className="fa-light fa-trash"
                                onClick={() => this.removeQuestion(id)}
                            />
                        </div>
                    ))}
                </div>
                <Button
                    label={i18n.t('certification.question.add')}
                    onClick={this.addQuestion}
                    disabled={questions.length >= qlistQuestions.length}
                    cssClass="regular secondary"
                />
                <div>
                    <Input
                        name="minQuestionsAnswered"
                        label={i18n.t('certification.question.minAnswered')}
                        isMandatory
                        validate={({ value }) => !Number.isNaN(parseInt(value, 10))}
                        defaultValue={R.pathOr(0, ['minQuestionsAnswered'], formData)}
                        onBlur={({ name, value }) => {
                            store.onChange({ name, value: parseInt(value, 10) }, null, [name])
                        }}
                    />
                </div>
            </div>
        )
    }
}

export default Questions
